export { SEMRESATTRS_DEPLOYMENT_ENVIRONMENT, SEMRESATTRS_SERVICE_NAME } from '@obrio/observability';

export {
  ATTRS_SPLIT_ID,
  ATTRS_USER_ID,
  ATTRS_ANALYTICS_EVENT_NAME,
  ATTRS_ANALYTICS_FUNNEL_NAME,
  ATTRS_ANALYTICS_FUNNEL_LOCALE,
  ATTRS_ANALYTICS_FUNNEL_SCREEN,
  ATTRS_ANALYTICS_FUNNEL_UTM_SECRET,
  ATTRS_ANALYTICS_FLOW_NAME,
  ATTRS_TYPE,
  ATTRS_ERROR_MESSAGE,
} from '@obrio/observability';

export const ATTRS_RESULT = 'result';
export const ATTRS_DESCRIPTION = 'description';

// ts-prune-ignore-next-line
export const ATTRS_REVALIDATION_SOURCE = 'revalidation.source';
// ts-prune-ignore-next-line
export const ATTRS_REVALIDATION_ACTION = 'revalidation.action';
